import { render, staticRenderFns } from "./BillableItemsTable.vue?vue&type=template&id=0bfbe08d&scoped=true"
import script from "./BillableItemsTable.vue?vue&type=script&lang=js"
export * from "./BillableItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfbe08d",
  null
  
)

export default component.exports